import React, { ReactNode, useCallback, useState } from 'react';

import { ServiceCard, SkeletonServiceCard, ContentField, LinkAsButton } from '@/shared/ui';

import { ROUTES_BY_SERVICE_CODE } from '@/router/config';

import { UserService } from '@/api/types';

import { InternalServicesDetailsModal } from '../InternalServicesDetailsModal/InternalServicesDetailsModal';

import './InternalServicesList.scss';

interface InternalServiceListProps {
  list: UserService[] | null;
}

const renderSkeletons = (): ReactNode[] =>
  Array.from({ length: 8 }, (_, idx) => idx).map((item) => <SkeletonServiceCard key={item} />);

export const InternalServicesList = React.memo<InternalServiceListProps>(({ list }) => {
  const [selectedService, setSelectedService] = useState<Nullable<UserService>>(null);

  const handleModalClose = useCallback(() => setSelectedService(null), []);

  const handleDetailsClick = useCallback((service: UserService) => {
    setSelectedService(service);
  }, []);

  if (list === null) return <div className="internal-services-page__list">{renderSkeletons()}</div>;
  if (list.length === 0)
    return <ContentField icon="no_result" content="За вашим запитом не знайдено жодного результату" />;

  return (
    <>
      <div className="internal-services-page__list">
        {list.map((service) => (
          <ServiceCard
            key={service.id}
            title={service.name}
            icon={service.icon}
            onDetailsClick={
              service.faq && service.faq?.length > 0 ? (): void => handleDetailsClick(service) : undefined
            }
            buttonLink={
              <LinkAsButton to={ROUTES_BY_SERVICE_CODE[service.code]} state={{ isFromService: true }}>
                {service.btn_cta || 'Замовити'}
              </LinkAsButton>
            }
          />
        ))}
      </div>
      {!!selectedService && <InternalServicesDetailsModal service={selectedService} onClose={handleModalClose} />}
    </>
  );
});
